const strictEmailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

// 사용 예시
export const validateStrictEmail = (email:string) => {
    return strictEmailRegex.test(email);
}
